/* istanbul ignore file */

import { useTranslation } from 'react-i18next'

import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts'

import { FormatNumber, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const RefundMethodsHalfPieChart = ({ data }) => {
  const { t } = useTranslation()

  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, iconPath, percentage }) => {
    const RADIAN = Math.PI / 180
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)

    if (percentage < 10) return null

    return <image href={iconPath} x={x - 15} y={y - 15} width={30} height={30} />
  }

  return (
    <Styles.ChartContainer>
      <Styles.ChartArea>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={data}
              cy="100%"
              startAngle={180}
              endAngle={0}
              innerRadius={60}
              outerRadius={150}
              dataKey="percentage"
              label={renderCustomLabel}
              labelLine={false}
            >
              <Cell fill={data[0].bulletColor} />
              <Cell fill={data[1].bulletColor} />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </Styles.ChartArea>
      <Styles.ValuesContainer>
        <div>
          <Text type="titleL">
            <FormatNumber style="percent">{data[0].percentage}</FormatNumber>
          </Text>
          <Styles.LabelContainer>
            <Text type="bodyMRegular">
              {t(data[0].label)}
              {data[0].isInstant && <span> {t('Instantáneo')}</span>}
            </Text>
          </Styles.LabelContainer>
        </div>
        <div>
          <Text type="titleL">
            <FormatNumber style="percent">{data[1].percentage}</FormatNumber>
          </Text>
          <Styles.LabelContainer>
            <Text type="bodyMRegular">
              {t(data[1].label)}
              {data[1].isInstant && <span> {t('Instantáneo')}</span>}
            </Text>
          </Styles.LabelContainer>
        </div>
      </Styles.ValuesContainer>
    </Styles.ChartContainer>
  )
}

export default RefundMethodsHalfPieChart
